export default __webpack_public_path__ + "static/media/Sansita-Bold.abb067a9.ttf";